import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CheckoutProcessContext } from '../../contexts/CheckoutProcessContext';
import { StripeShippingAddress } from './StripeShippingAddress';

export class ShippingAddress extends Component {
  render() {
    return (
      <CheckoutProcessContext.Consumer>
        {({ TranslationContext, LocalizedAddress }) => (
          <TranslationContext.Consumer>
            {(t) => (
              <section className="checkout-form__section">
                <div className="form-card__content">

                
                <div className="input">
                  <div
                    className={`input__checkbox tos__checkbox ${
                      !this.props.useShippingAddress ? 'input__checkbox--selected' : ''
                    }`}
                  >
                    <div className="input__checkbox-wrap">
                      <div className="input__checkbox__input">
                        <input
                          type="checkbox"
                          name="use_shipping_address"
                          id="use_shipping_address"
                          onChange={this.props.onUseShippingAddressChange}
                          checked={this.props.useShippingAddress}
                        />
                      </div>
                      <label htmlFor="use_shipping_address" className="input__checkbox__label">
                        {t.t(
                          this.props.customerAddress
                            ? 'checkout__use_customer__address'
                            : 'checkout__use_delivery_address',
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div>
                  {!this.props.useShippingAddress && this.props.isStripeGateway && (
                    <StripeShippingAddress
                      locale={this.props.locale}
                      address={this.props.address}
                      onAddressChange={this.props.onAddressChange}
                      isPhoneRequired={this.props.isPhoneRequired}
                      onCompleteChanged={this.props.onCompleteChanged}
                    />
                  )}
                  {!this.props.useShippingAddress && !this.props.isStripeGateway && (
                    <LocalizedAddress
                      {...this.props.address}
                      onAddressChange={this.props.onAddressChange}
                      header={t.t('checkout__delivery_address')}
                    />
                  )}
                </div>
                </div>
              </section>
            )}
          </TranslationContext.Consumer>
        )}
      </CheckoutProcessContext.Consumer>
    );
  }
}

ShippingAddress.propTypes = {
  address: PropTypes.object.isRequired,
  onAddressChange: PropTypes.func.isRequired,
  useShippingAddress: PropTypes.bool.isRequired,
  onUseShippingAddressChange: PropTypes.func.isRequired,
};

export default ShippingAddress;
